import { isNativePlatform, meditationStyleId, pilatesTypeId, pranayamaStyleId, fitSessionsTypeId, discoveriesTagId } from 'src/config';
import { useUserState } from 'src/contexts/UserContext';
import AppWrapper from 'src/features/AppWrapper';
import { FilterTrait } from 'src/models/SessionFilters';
import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import {
  Home,
  Login,
  LogOut,
  Profile,
  SignUp,
  Session,
  SessionsList,
  Welcome,
  ResetPassword,
  Challenge,
  ChallengeBySession,
  ChallengeLibrary,
  PracticePlan,
  PracticePlanBySession,
  PracticePlanLibrary,
  Likes,
  Visits,
  Coaches,
  BenefitsLibrary,
  BenefitDetail,
  CarouselPreview,
  KnowledgePage,
  RecipesPage,
} from 'src/views';
import { LoginMobile } from '../views/LoginMobile/LoginMobile';

import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import { PaymentComplete } from '../views/SignUp/OneTimePayment/PaymentComplete';
import { PaymentIssueModal } from '../views/Profile/features/PaymentIssueModal';
import { useVirtualPageView } from '../services/GTMService';

const coachIds = {
  joga: new Set([
    '05f2ed4c-6411-44ac-b3d2-bccdaddd3b4c', '1899bbb6-3e66-4af3-b714-7f26bfcac703',
    '2052bf3f-0624-422a-92c7-7fddf86d41ff', '22aa74e1-68c0-4fd9-af50-1fe6a207abec',
    '29989c47-c87d-4d01-a5de-fe77053ccf16', '2c14a68f-09c3-4645-b885-6cb794887ab9',
    '2cd9663a-5c64-4f7e-9d61-78373e635071', '2dc6df11-50e0-4a00-9989-27537a906f56',
    '2f0ccf80-3e9d-4c2f-af2c-a59c4961ea62', '2fcf3ea6-3155-4173-aff0-aaacaf834c3c',
    '3444ccde-3400-4c1a-93c6-650e278ba60c', '3b67e9ce-d8e0-49f1-ac05-14c03748079b',
    '3b7386a2-810e-4419-bbb4-7aed6e0fbdb3', '442fe178-76c5-4f96-bdcf-c5dbb4f8d434',
    '4668f2f2-ddbb-4335-89bc-e81bd0aff3b4', '4e51338f-4f15-468d-8c8e-2d2273104d5e',
    '6128e47e-2992-4d27-b27f-b44e7578902d', '61967a95-93ba-4c57-bdfc-06a68e2ecbf3',
    '69744023-9a29-4af1-9360-e86fedb09b28', '7773de6a-a288-497f-9f6a-ffdb30e030e9',
    '7a934d57-228e-4800-a56d-80ad564af15c', '7b4e3ce9-6e48-4675-bcd2-657e97f9d3d8',
    '88bdf1e8-5f14-481f-939b-72eb77753b7c', '8cc54310-174f-4ba4-8ff9-53073c470daa',
    '8e9b276e-2547-4eca-a805-89c157b093de', '8fa29467-daac-44f5-b690-2e98f8e51836',
    '91370c61-d38b-405a-b413-3d60202fe08c', '94ef122c-cdc6-44cb-8fc3-619e23c0f619',
    '9d245942-401b-4a82-88a0-c956a1aa224f', 'a33942e0-1307-4bc4-8911-d30be250f05a',
    'a5c647df-faf5-41b2-9f71-2427eb73949d', 'aa0dcd36-6e34-4bfd-b383-ef4a34a788f1',
    'aae47cd7-b52d-4c6b-9b72-d8b7291a6f78', 'ae194ebc-7d6f-41c6-932c-327fb1d88dc6',
    'b1026bd6-7211-4a3b-b0d4-e1ff9644f97c', 'b89f0a51-3235-4ca4-ae6e-b535f4196dce',
    'bd526ba3-4330-4e76-85c1-e78f31e435ea', 'c2acdfac-8e36-4400-9452-f45e02266757',
    'c356d575-35e0-4ce7-a462-c1d2df456c14', 'c6b04bf8-dd08-4144-b8be-48c5232f6222',
    'c9323833-3bb8-45df-9c94-3adf2bbcc858', 'db653be3-a890-4a76-b5d2-2279c62b343f',
    'de6b860a-d3c8-4d85-9b3e-747db6443e01', 'dff5c3f1-1fa8-4030-ace1-bd79052d2bf5',
    'dffb71b5-cb8e-41aa-ba92-7b0472355b8d', 'e31000c2-d4b9-4710-a3cd-cb96747825cc',
    'e4808361-b682-486c-ae38-bbad25c18ac2', 'e4895100-9fc5-4312-973c-1f3fa1369cb2',
    'ea8845f6-747b-48d3-9bde-74ef57ddd326', 'eec5ab3a-92a0-4588-87fd-4570c7eb9f64',
    'ef4a8ebb-fa03-4b96-bf99-f8046ca7ed4e', 'f18ca76f-114c-43a8-846b-c153daa3a594',
    'f218bf71-b629-4050-bf9a-9113b9e9a863', 'f47605df-68d3-4c05-8b77-d7342b63d059',
    'fa8e95c1-5049-4db1-b665-59a4c8ebb180', 'fecab1a7-036a-4a33-8827-6e89953ff028',
  ]),
  medytacja: new Set([
    '25f81cbb-54b1-401c-80e0-a741bf74a8f0', '2c14a68f-09c3-4645-b885-6cb794887ab9',
    '442fe178-76c5-4f96-bdcf-c5dbb4f8d434', '496c7018-3a67-44dc-9a7c-2f8d643c7e3a',
    '4cf841f3-0125-4dc7-ab2a-e74f50fbf0ad', '6128e47e-2992-4d27-b27f-b44e7578902d',
    '7b4e3ce9-6e48-4675-bcd2-657e97f9d3d8', '88bdf1e8-5f14-481f-939b-72eb77753b7c',
    '8fa29467-daac-44f5-b690-2e98f8e51836', 'a33942e0-1307-4bc4-8911-d30be250f05a',
    'b89f0a51-3235-4ca4-ae6e-b535f4196dce', 'c2acdfac-8e36-4400-9452-f45e02266757',
    'ea8845f6-747b-48d3-9bde-74ef57ddd326',
  ]),
  pranayama: new Set([
    '2cdea6f5-3fae-4e09-9547-4b6618675246', '7b4e3ce9-6e48-4675-bcd2-657e97f9d3d8',
    '94ef122c-cdc6-44cb-8fc3-619e23c0f619', 'e4895100-9fc5-4312-973c-1f3fa1369cb2',
    'ea8845f6-747b-48d3-9bde-74ef57ddd326', 'fa8e95c1-5049-4db1-b665-59a4c8ebb180',
  ]),
  pilates: new Set([
    '34cf8667-d522-47ee-b95a-c5b30aa451e0', '9fc4f4e7-1f4f-47fb-944e-6b9f239cc815',
    'de6b860a-d3c8-4d85-9b3e-747db6443e01', 'dfd033eb-f65e-47b1-8f78-5455709e908c',
  ]),
  fit: new Set([
    'de6b860a-d3c8-4d85-9b3e-747db6443e01',
  ]),
};

const App: React.FC = () => {
  const { isLoggedIn } = useUserState();
  useVirtualPageView();

  return (
    <AppWrapper
      navbar={isLoggedIn}
      emptyNavbar={!isLoggedIn}
    >
      <PaymentIssueModal />
      <Switch>
        <PublicRoute
          path="/login"
          component={isNativePlatform ? LoginMobile : Login}
        />
        <ProtectedRoute
          path="/logout"
          component={LogOut}
        />
        <PublicRoute
          path="/payment/complete"
          exact
          component={PaymentComplete}
        />
        {!isNativePlatform && (
          <PublicRoute
            path="/register/:description/:subscriptionProductId/:couponCode?"
            exact
            component={SignUp}
          />
        )}
        <PublicRoute
          path="/reset-password/:token?"
          component={ResetPassword}
        />
        <ProtectedRoute
          path="/home"
          requiresSubscription
          component={Home}
        />
        <ProtectedRoute
          path="/welcome"
          requiresSubscription
          component={Welcome}
        />
        <ProtectedRoute
          path="/all"
          exact
          requiresSubscription
          render={() =>
            <SessionsList
              pathBase="all"
            />
          }
        />
        <ProtectedRoute
          path='/all/:id'
          requiresSubscription
          render={() => <Session />}
        />
        <ProtectedRoute
          path="/sessions"
          exact
          requiresSubscription
          render={() =>
            <SessionsList
              pathBase="sessions"
              exclude={{
                [FilterTrait.Style]: [meditationStyleId, pranayamaStyleId],
                [FilterTrait.Type]: [pilatesTypeId, fitSessionsTypeId],
                [FilterTrait.Tag]: [discoveriesTagId]
              }}
              allowedCoachIds={coachIds.joga}
            />
          }
        />
        <ProtectedRoute
          path='/sessions/:id'
          requiresSubscription
          render={() => <Session />}
        />
        <ProtectedRoute
          path="/meditations"
          exact
          requiresSubscription
          render={() => (
            <SessionsList
              pathBase="meditations"
              presetFilters={[{ trait: FilterTrait.Style, value: meditationStyleId }]}
              defaultTitle="Medytacje"
              defaultUnderline="Znajdź idealnie dopasowaną praktykę"
              carouselPage="meditations"
              allowedCoachIds={coachIds.medytacja}
            />
          )}
        />
        <ProtectedRoute
          path="/pilates"
          exact
          requiresSubscription
          render={() => (
            <SessionsList
              pathBase="pilates"
              presetFilters={[{ trait: FilterTrait.Type, value: pilatesTypeId }]}
              defaultTitle="Pilates"
              carouselPage="pilates"
              allowedCoachIds={coachIds.pilates}
            />
          )}
        />
        <ProtectedRoute
          path="/pranayama"
          exact
          requiresSubscription
          render={() => (
            <SessionsList
              pathBase="pranayama"
              presetFilters={[{ trait: FilterTrait.Style, value: pranayamaStyleId }]}
              defaultTitle="Pranayama/Oddech"
              carouselPage="pranayama"
              allowedCoachIds={coachIds.pranayama}
            />
          )}
        />
        <ProtectedRoute
          path="/fit-sessions"
          exact
          requiresSubscription
          render={() => (
            <SessionsList
              pathBase="fit-sessions"
              presetFilters={[{ trait: FilterTrait.Type, value: fitSessionsTypeId }]}
              defaultTitle="Zajęcia fit"
              carouselPage="fitSessions"
              allowedCoachIds={coachIds.fit}
            />
          )}
        />
        <ProtectedRoute
          path="/discoveries"
          exact
          requiresSubscription
          render={() => (
            <SessionsList
              pathBase="discoveries"
              presetFilters={[{ trait: FilterTrait.Tag, value: discoveriesTagId }]}
              lockPresetFilters
              hideLockedPresetChips
              defaultTitle="Odkrycia PortalYogi"
              defaultUnderline="Inspirujące praktyki wybrane specjalnie dla Ciebie"
              searchboxTitle="Odkrycia PortalYogi"
              searchboxUnderline="Przeglądaj sesje, które otwierają nowe perspektywy w Twojej praktyce."
              carouselPage="discoveries"
            />
          )}
        />
        <ProtectedRoute
          path={'/meditations/:id'}
          requiresSubscription
          render={() => <Session />}
        />
        <ProtectedRoute
          path={'/pilates/:id'}
          requiresSubscription
          render={() => <Session />}
        />
        <ProtectedRoute
          path={'/pranayama/:id'}
          requiresSubscription
          render={() => <Session />}
        />
        <ProtectedRoute
          path={'/fit-sessions/:id'}
          requiresSubscription
          render={() => <Session />}
        />
        <ProtectedRoute
          path={'/discoveries/:id'}
          requiresSubscription
          render={() => <Session />}
        />
        <ProtectedRoute
          path="/challenges"
          exact
          requiresSubscription
          component={ChallengeLibrary}
        />
        <ProtectedRoute
          path="/practice-plans"
          exact
          requiresSubscription
          component={PracticePlanLibrary}
        />
        <ProtectedRoute
          path="/practice-plans/:id/:stepId?"
          exact
          requiresSubscription
          component={PracticePlan}
        />
        <ProtectedRoute
          path="/practice-plans/session/:challengeSessionId"
          exact
          requiresSubscription
          component={PracticePlanBySession}
        />
        <ProtectedRoute
          path="/teachers"
          exact
          requiresSubscription
          component={Coaches}
        />
        <ProtectedRoute
          path="/benefits"
          exact
          requiresSubscription
          component={BenefitsLibrary}
        />
        <ProtectedRoute
          path="/benefits/:id"
          exact
          requiresSubscription
          component={BenefitDetail}
        />
        <ProtectedRoute
          path="/knowledge/conversations"
          exact
          requiresSubscription
          component={KnowledgePage}
        />
        <ProtectedRoute
          path="/knowledge/podcast"
          exact
          requiresSubscription
          component={KnowledgePage}
        />
        <ProtectedRoute
          path="/knowledge/ebooks"
          exact
          requiresSubscription
          component={KnowledgePage}
        />
        <ProtectedRoute
          path="/recipes"
          exact
          requiresSubscription
          component={RecipesPage}
        />
        <ProtectedRoute
          path="/challenges/session/:challengeSessionId"
          exact
          requiresSubscription
          component={ChallengeBySession}
        />
        <ProtectedRoute
          path="/challenges/:id/:stepId?"
          exact
          requiresSubscription
          component={Challenge}
        />
        <ProtectedRoute
          path="/likes"
          exact
          requiresSubscription
          component={Likes}
        />
        <ProtectedRoute
          path="/activity"
          exact
          requiresSubscription
          component={Visits}
        />
        <ProtectedRoute
          path="/me/*"
          component={Profile}
        />
        <ProtectedRoute
          path="/carousel/:id"
          exact
          requiresSubscription
          render={(p: any) => <CarouselPreview id={p.match.params.id} />}
        />
        <ProtectedRoute
          path="*"
          render={() => <Redirect to="/home" />}
        />
      </Switch>
    </AppWrapper>
  );
};

export default App;
